import { SafeArea } from "antd-mobile";
import { PropsWithChildren } from "react";
import styles from "./index.module.scss";
type PageLayoutProps = {
  title?: string;
  footer?: React.ReactNode;
  header?: React.ReactNode;
  bg?: boolean;
  className?: string;
};
// TODO: 待优化
export function PageLayout(props: PropsWithChildren<PageLayoutProps>) {
  return <main className={`${styles.page} ${props.bg ? styles.bg : ""} ${props.className || ""}`} data-sentry-component="PageLayout" data-sentry-source-file="index.tsx">
      <header className={styles.page_header}>{props.header || null}</header>
      <article className={styles.page_content}>{props.children}</article>
      {props.footer ? <footer className={styles.page_footer}>{props.footer}</footer> : null}

      <SafeArea position="bottom" data-sentry-element="SafeArea" data-sentry-source-file="index.tsx" />
    </main>;
}
export default PageLayout;